export default "__VITE_ASSET__C3TtjF2L__"